import { render, staticRenderFns } from "./BinnacleList.vue?vue&type=template&id=704d506e&"
import script from "./BinnacleList.vue?vue&type=script&lang=js&"
export * from "./BinnacleList.vue?vue&type=script&lang=js&"
import style0 from "./BinnacleList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704d506e')) {
      api.createRecord('704d506e', component.options)
    } else {
      api.reload('704d506e', component.options)
    }
    module.hot.accept("./BinnacleList.vue?vue&type=template&id=704d506e&", function () {
      api.rerender('704d506e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/_vue/componentes/BinnacleList.vue"
export default component.exports